import { Attachment, AttachPayload } from 'types/application';
import {
    attachmentPayloadSetting,
    attachmentRetrieve,
    payloadDeleteApplication,
    formDeleteApplication,
    formatDateTime,
    payloadFVGDeleteApplication
} from '../helpers';

import {
    GENRE_DETAILS,
    ORGANISATION_DETAILS,
    OTHER_DETAILS,
    SECT_ADDRESS,
    SECT_APPLICANT,
    TITLE_DETAILS
} from 'common/application.const/VideoGames/classificationOfVideoGames';

import { DetailsType, FormData } from 'types/application';
import {
    CONTENT_QUESTIONS_I,
    CONTENT_QUESTIONS_II,
    CONTENT_QUESTIONS_III,
    CONTENT_QUESTIONS_IV
} from 'common/application.const/VideoGames/ContentQuestion';
import { ADDITIONAL_INFORMATION, APPLICATION_SUBMISSION } from 'common/application.const/VideoGames/applicationSubmission';
import { requestAttachmentFVG, requestAttachmentList } from 'store/api/application.api';

type Props = {
    myInfoContent: any;
    uen?: string;
    id?: string;
    userRole?: string;
};

const selectFormVideoGame = (applicationForm: string) => {
    // Exhibition
    if (applicationForm === 'Classification of Video Games') return 'classificationOfVideoGames';
    if (applicationForm === 'Declaration of Interactive Software') return 'declarationForInteractiveSoftware';
};

export const autoFillData = ({ myInfoContent, uen, id, userRole }: Props) => {
    const general_selected = userRole === 'corppass' ? 'generalCompany' : 'generalApplicant';
    const person = myInfoContent?.corppass || myInfoContent || {};
    const entity = myInfoContent?.['basic-profile'] || {};
    const corpUser = person?.['corppass-user'] || {};
    const address = myInfoContent?.address || person?.regadd || {};
    const isFin = ['F', 'G', 'M'].some((pre: string) => person?.uinfin?.value?.startsWith(pre));

    let idType;

    if (isFin) idType = 'IDT2';

    if (person?.nationality?.code && !isFin) {
        idType = person.nationality.code === 'SG' ? 'IDT' : '';
    }

    let salutation = '';
    if (person.sex) {
        salutation = person.sex?.code === 'M' ? 'Mr.' : 'Ms.';
    }

    let corpUserID = corpUser['id-type']?.desc;

    if (corpUserID === 'NRIC') corpUserID = 'IDT';
    if (corpUserID === 'FIN') corpUserID = 'IDT2';

    const generalForm = {
        id: general_selected,
        formID: `appDetails-${general_selected}`,
        hasError: true,
        values: {
            [`${SECT_APPLICANT}-id-type`]: corpUserID || idType,
            [`${SECT_APPLICANT}-idno`]: corpUser['id-no']?.value || person?.uinfin?.value,
            [`${SECT_APPLICANT}-salutaion`]: salutation,
            [`${SECT_APPLICANT}-name`]: corpUser.name?.value || person?.name?.value,
            [`${SECT_APPLICANT}-mobile-no-country-code`]: person?.mobileno?.areacode?.value || '65',
            [`${SECT_APPLICANT}-mobile-no-main`]: person?.mobile?.value || person?.mobileno?.nbr?.value,
            [`${SECT_APPLICANT}-email`]: person?.email?.value,
            // [`${SECT_APPLICANT}-nationality`]: person?.nationality?.code,

            [`${ORGANISATION_DETAILS}-organisation-uen-no`]: entity.uen?.value,
            [`${ORGANISATION_DETAILS}-organisation-name`]: entity['entity-name']?.value,

            [`${SECT_ADDRESS}-postal`]: address.postal?.value,
            [`${SECT_ADDRESS}-block-house`]: address.block?.value,
            [`${SECT_ADDRESS}-street`]: address.street?.value,
            [`${SECT_ADDRESS}-floor`]: address.floor?.value,
            [`${SECT_ADDRESS}-unit`]: address.unit?.value,
            [`${SECT_ADDRESS}-building`]: address.building?.value
        }
    };

    return generalForm;
};

export const formatRetrieve = async (
    _content: any,
    _caseTypeID: string,
    _action?: string,
    applicationForm?: string,
    userRole?: string,
    dropdownOpts?: any,
    newApplication?: boolean
) => {
    if (_action === 'application-delete') return formDeleteApplication;
    const general_selected = userRole === 'corppass' ? 'generalCompany' : 'generalApplicant';
    const selectedForm = selectFormVideoGame(applicationForm ?? '');
    const applicantValues = _content.applicant || {};
    const companyValues = _content.company || {};
    const applicantContact = applicantValues.ContactPage || {};
    const companyContact = companyValues.ContactPage || {};
    // const applicantAddress =
    //     applicantValues.Address && applicantValues.Address.length > 0 ? applicantValues.Address[0]?.MailingAddress || {} : {};
    // const companyAddress = companyValues.Address && companyValues.Address.length > 0 ? companyValues.Address[0]?.MailingAddress || {} : {};
    const applicantAddress = applicantValues.MailingAddress || {};
    const companyAddress = companyValues.MailingAddress || {};
    const videogame = _content?.FVGApplication?.VideoGameDetails || {};
    const additionalInfoRemarks = _content?.AdditionalInfoRemarks;

    let summary;
    let general;
    let title;
    let genre;
    let others;
    let question1;
    let question2;
    let question3;
    let question4;
    let appSubmission;
    let videoGamesDetails;
    let additionalInformation;
    let downloads = {};

    if (_action === 'download') {
        const uploadedFiles = (
            _caseTypeID
                ? await requestAttachmentFVG(_caseTypeID).then((res) =>
                      res.map((i: any) => ({
                          ...i,
                          pyCategory:
                              i.Type === 'Application' && i.pyCategory === 'Receipt'
                                  ? 'Payment Receipt'
                                  : i.Type === 'Application' && i.pyCategory === 'Invoice'
                                    ? 'Invoice'
                                    : i.Type === 'Appeal' && i.pyCategory === 'Receipt'
                                      ? 'Appeal Receipt'
                                      : i.Type === 'Appeal' && i.pyCategory === 'Invoice'
                                        ? 'Appeal Invoice'
                                        : i.pyCategory === 'SubmissionReceipt'
                                          ? 'Submission Receipt'
                                          : i.pyCategory === 'Notification'
                                            ? 'Notification'
                                            : i.pyCategory
                      }))
                  )
                : []
        ) as any[];

        let files = {};

        if (_content?.CustomerStatus === 'Rejected' || _content?.CustomerStatus === 'Withdrawn' || _content?.CustomerStatus === 'Voided') {
            files = uploadedFiles
                .filter((i) => i.pyCategory !== 'Certificate' && i.pyCategory !== 'Notification')
                .map((i) => {
                    return {
                        id: 'FVGFiles',
                        data: [i.fileName, i.pyCategory, 'Download'],
                        fileName: i.fileName,
                        pyCategory: i.pyCategory,
                        DownloadLink: i.DownloadLink
                    };
                });
        } else if (
            _content?.CustomerStatus === 'Submitted' ||
            _content?.CustomerStatus === 'Processing' ||
            _content?.CustomerStatus === 'Pending Payment'
        ) {
            files = uploadedFiles
                .filter((i) => i.pyCategory !== 'Certificate' && i.pyCategory !== 'Notification')
                .map((i) => {
                    return {
                        id: 'FVGFiles',
                        data: [i.fileName, i.pyCategory, 'Download'],
                        fileName: i.fileName,
                        pyCategory: i.pyCategory,
                        DownloadLink: i.DownloadLink
                    };
                });
        } else {
            files = uploadedFiles.map((i) => {
                return {
                    id: 'FVGFiles',
                    data: [i.fileName, i.pyCategory, 'Download'],
                    fileName: i.fileName,
                    pyCategory: i.pyCategory,
                    DownloadLink: i.DownloadLink
                };
            });
        }
        downloads = {
            id: 'download',
            formID: 'download',
            hasError: true,
            values: { files }
        };

        return [downloads];
    }

    if (_content?.FVGApplication?.VideoGameDetails) {
        let attachmentsFromBEP: any;

        if (!newApplication) {
            const uploadedFiles = (_caseTypeID ? await requestAttachmentList(_caseTypeID) : []) as AttachPayload[];

            const filterUploadedFiles = uploadedFiles.filter((i) => i.category === 'SupportingDocuments');
            attachmentsFromBEP = filterUploadedFiles.map((i) => {
                return {
                    FileID: i.ID,
                    FileName: i.fileName,
                    FileType: i.mimeType
                };
            });
        }

        if (_action === 'pendingaddinfo') {
            additionalInformation = {
                id: `videogames-additional-information`,
                formID: 'videogamesAdditionalInformation',
                hasError: true,
                values: {
                    [`${ADDITIONAL_INFORMATION}-remarks-to-applicant`]: additionalInfoRemarks || '',
                    [`${ADDITIONAL_INFORMATION}-tentative-rating`]: '',
                    [`${ADDITIONAL_INFORMATION}-format`]: '',
                    [`${ADDITIONAL_INFORMATION}-online-link`]: '',
                    [`${ADDITIONAL_INFORMATION}-id-username`]: '',
                    [`${ADDITIONAL_INFORMATION}-password`]: '',
                    [`${ADDITIONAL_INFORMATION}-dateCombo-main`]: '',
                    [`${ADDITIONAL_INFORMATION}-dateCombo-radio-day`]: 'AM',
                    [`${ADDITIONAL_INFORMATION}-remarks`]: ''
                }
            };

            return [additionalInformation];
        }

        summary = {
            id: 'summary',
            formID: 'summary',
            hasError: true,
            values: {
                [`summary-transactionType`]: _content?.pyStatusCustomerSat,
                [`summary-title`]: _content?.Title,
                [`summary-application-name`]: _content?.ApplicationType,
                [`summary-application-category`]: '',
                [`summary-application-number`]: _content?.ApplicationType,
                [`summary-application-businessStatus`]: _content?.BusinessStatus,
                [`summary-application-submission`]: _content?.pxCommitDateTime,
                [`summary-gbl-id`]: _content?.IDNo,
                [`summary-id`]: _content?.caseid,
                [`summary-status`]: _content?.CustomerStatus,
                [`summary-start-date`]: '',
                [`summary-expiry-date`]: '',
                [`summary-date-submission`]: formatDateTime(_content?.pxCreateDateTime),
                caseID: _content?.caseid
            }
        };

        general = {
            id: general_selected,
            formID: `appDetails-${general_selected}`,
            title: general_selected === 'generalCompany' ? 'Organisation Details' : 'Applicant Details',
            hasError: true,
            values: {
                [`${SECT_APPLICANT}-id-type`]:
                    dropdownOpts?.IDTypeFVG?.find((i: any) => i.optLabel === applicantValues.IDType)?.optID || applicantValues.IDType,
                [`${SECT_APPLICANT}-idno`]: applicantValues.IDNo,
                [`${SECT_APPLICANT}-salutaion`]: applicantValues.Salutation,
                [`${SECT_APPLICANT}-name`]: applicantValues.Name,
                [`${SECT_APPLICANT}-email`]: applicantContact.EmailAddress,
                [`${SECT_APPLICANT}-other-email`]: applicantContact.OtherEmailAddress,
                [`${SECT_APPLICANT}-mobile-no-country-code`]: applicantContact.MobileNoCountryCode || '65',
                [`${SECT_APPLICANT}-mobile-no-main`]: applicantContact.ContactNumber?.slice(3),
                [`${SECT_APPLICANT}-other-mobile-no-country-code`]: applicantContact.OtherPhoneNumberCountryCode || '65',
                [`${SECT_APPLICANT}-other-mobile-no-main`]: applicantContact.OtherContactNumber?.slice(3),
                // [`${SECT_APPLICANT}-nationality`]: applicantValues.Nationality,

                [`${ORGANISATION_DETAILS}-organisation-uen-no`]: companyValues.UEN,
                [`${ORGANISATION_DETAILS}-organisation-name`]: companyValues.CompanyName,
                [`${ORGANISATION_DETAILS}-organisation-mobile-no-country-code`]: companyContact.MobileNoCountryCode || '65',
                [`${ORGANISATION_DETAILS}-organisation-mobile-no-main`]: companyContact.MobileNo,
                [`${ORGANISATION_DETAILS}-organisation-email`]: companyContact.EmailAddress,

                [`${SECT_ADDRESS}-postal`]: applicantAddress.PostalCode || companyAddress.PostalCode,
                [`${SECT_ADDRESS}-block-house`]: applicantAddress.BlockNumber || companyAddress.BlockNumber,
                [`${SECT_ADDRESS}-street`]: applicantAddress.StreetName || companyAddress.StreetName,
                [`${SECT_ADDRESS}-floor`]: applicantAddress.FloorNumber || companyAddress.FloorNumber,
                [`${SECT_ADDRESS}-unit`]: applicantAddress.UnitNumber || companyAddress.UnitNumber,
                [`${SECT_ADDRESS}-building`]: applicantAddress.BuildingName || companyAddress.BuildingName
            }
        };

        const platformArr = videogame.Platform;
        const regionArr = videogame.Region;

        title = {
            id: 'videogames-title',
            formID: 'appDetails-title',
            hasError: true,
            values: {
                [`${TITLE_DETAILS}-_title`]: videogame.Title || '',
                [`${TITLE_DETAILS}-romanized-title`]: videogame.RomanizedTitle || '',
                [`${TITLE_DETAILS}-publisher`]: videogame.Publisher || '',
                [`${TITLE_DETAILS}-year-production`]: videogame.ReleaseYear || '',
                [`${TITLE_DETAILS}-region`]: regionArr?.split(',') || [],
                [`${TITLE_DETAILS}-platform`]: platformArr?.split(',') || '',
                [`${TITLE_DETAILS}-others`]: videogame.OtherPlatform || ''
            }
        };

        const genre1 = videogame.Genre1?.split(',')[0]?.trim();
        const genre2 = videogame.Genre2?.split(',')[0]?.trim();
        const subGenre1 = videogame.Genre1?.split(',')[1]?.trim();
        const subGenre2 = videogame.Genre2?.split(',')[1]?.trim();

        genre = {
            id: `videogames-genre`,
            formID: 'appDetails-genre',
            hasError: true,
            values: {
                [`${GENRE_DETAILS}-action`]: genre1 === 'Action' || genre2 === 'Action' ? 'Yes' : '',
                [`${GENRE_DETAILS}-action-sub-genre`]:
                    dropdownOpts?.Action.find((i: any) => i.optID === subGenre1 || i.optID === subGenre2)?.optID || '',
                [`${GENRE_DETAILS}-adventure`]: genre1 === 'Adventure' || genre2 === 'Adventure' ? 'Yes' : '',
                [`${GENRE_DETAILS}-adventure-sub-genre`]:
                    dropdownOpts?.Adventure.find((i: any) => i.optID === subGenre1 || i.optID === subGenre2)?.optID || '',
                [`${GENRE_DETAILS}-fighting`]: genre1 === 'Fighting' || genre2 === 'Fighting' ? 'Yes' : '',
                [`${GENRE_DETAILS}-fighting-sub-genre`]:
                    dropdownOpts?.Fighting.find((i: any) => i.optID === subGenre1 || i.optID === subGenre2)?.optID || '',
                [`${GENRE_DETAILS}-puzzle`]: genre1 === 'Puzzle' || genre2 === 'Puzzle' ? 'Yes' : '',
                [`${GENRE_DETAILS}-racing`]: genre1 === 'Racing' || genre2 === 'Racing' ? 'Yes' : '',
                [`${GENRE_DETAILS}-racing-sub-genre`]:
                    dropdownOpts?.Racing.find((i: any) => i.optID === subGenre1 || i.optID === subGenre2)?.optID || '',
                [`${GENRE_DETAILS}-rpg`]: genre1 === 'Role Playing Games(RPG)' || genre2 === 'Role Playing Games(RPG)' ? 'Yes' : '',
                [`${GENRE_DETAILS}-rpg-sub-genre`]:
                    dropdownOpts?.['Role Playing Games(RPG)'].find((i: any) => i.optID === subGenre1 || i.optID === subGenre2)?.optID || '',
                [`${GENRE_DETAILS}-simulation`]: genre1 === 'Simulation' || genre2 === 'Simulation' ? 'Yes' : '',
                [`${GENRE_DETAILS}-simulation-sub-genre`]:
                    dropdownOpts?.Simulation.find((i: any) => i.optID === subGenre1 || i.optID === subGenre2)?.optID || '',
                [`${GENRE_DETAILS}-sports`]: genre1 === 'Sports' || genre2 === 'Sports' ? 'Yes' : '',
                [`${GENRE_DETAILS}-other`]: genre1 === 'Other' || genre2 === 'Other' ? 'Yes' : '',
                [`${GENRE_DETAILS}-other-sub-genre`]:
                    dropdownOpts?.Other.find((i: any) => i.optID === subGenre1 || i.optID === subGenre2)?.optID || '',
                [`${GENRE_DETAILS}-strategy`]: genre1 === 'Strategy' || genre2 === 'Strategy' ? 'Yes' : '',
                [`${GENRE_DETAILS}-strategy-sub-genre`]:
                    dropdownOpts?.Strategy.find((i: any) => i.optID === subGenre1 || i.optID === subGenre2)?.optID || ''
            }
        };

        const selectedRatings = videogame.Ratings?.filter((i: any) => i.pySelected === 'true').map((i: any) => i.Agency);

        others = {
            id: `videogames-others`,
            formID: 'appDetails-others',
            hasError: true,
            values: {
                [`${OTHER_DETAILS}-ratings`]: selectedRatings?.length <= 0 ? '' : selectedRatings,
                [`${OTHER_DETAILS}-esrb-rating`]: videogame.Ratings?.[1].AgenciesInputRemarks || '',
                [`${OTHER_DETAILS}-esrb-consumer-advice`]: videogame.Ratings?.[1].ConsumerAdvice || '',
                [`${OTHER_DETAILS}-pegi-rating`]: videogame.Ratings?.[2].AgenciesInputRemarks || '',
                [`${OTHER_DETAILS}-pegi-consumer-advice`]: videogame.Ratings?.[2].ConsumerAdvice || '',
                [`${OTHER_DETAILS}-acb-rating`]: videogame.Ratings?.[3].AgenciesInputRemarks || '',
                [`${OTHER_DETAILS}-acb-consumer-advice`]: videogame.Ratings?.[3].ConsumerAdvice || '',
                [`${OTHER_DETAILS}-cero-rating`]: videogame.Ratings?.[4].AgenciesInputRemarks || '',
                [`${OTHER_DETAILS}-cero-consumer-advice`]: videogame.Ratings?.[4].ConsumerAdvice || '',
                [`${OTHER_DETAILS}-others`]: videogame.Ratings?.[5].ConsumerAdvice || ''
            }
        };

        question1 = {
            id: `videogames-content-1`,
            formID: 'content-1',
            hasError: true,
            values: {
                [`${CONTENT_QUESTIONS_I}-question`]: videogame.Question1Answer || ''
            }
        };

        question2 = {
            id: `videogames-content-2`,
            formID: 'content-2',
            hasError: true,
            values: {
                [`${CONTENT_QUESTIONS_II}-question`]: videogame.Question2Answer || ''
            }
        };

        question3 = {
            id: `videogames-content-3`,
            formID: 'content-3',
            hasError: true,
            values: {
                [`${CONTENT_QUESTIONS_III}-question`]: videogame.Question3Answer || ''
            }
        };

        question4 = {
            id: `videogames-content-4`,
            formID: 'content-4',
            hasError: true,
            values: {
                [`${CONTENT_QUESTIONS_IV}-question`]: videogame.Question4Answer || ''
            }
        };

        appSubmission = {
            id: `videogames-submission`,
            formID: 'appSubmission',
            hasError: true,
            values: {
                [`${APPLICATION_SUBMISSION}-tentative-rating`]: videogame.TentativeRating || '',
                [`${APPLICATION_SUBMISSION}-format`]: videogame.SubmissionDetails.Format || '',
                [`${APPLICATION_SUBMISSION}-online-link`]: videogame.SubmissionDetails.OnlineLink || '',
                [`${APPLICATION_SUBMISSION}-id-username`]: videogame.SubmissionDetails.pyUserName || '',
                [`${APPLICATION_SUBMISSION}-password`]: videogame.SubmissionDetails.PasswordValue || '',
                [`${APPLICATION_SUBMISSION}-dateCombo-main`]: videogame.SubmissionDetails.AppointmentDate || '',
                [`${APPLICATION_SUBMISSION}-dateCombo-radio-day`]: videogame.SubmissionDetails.AppointmentTimeTo || 'AM',
                [`${APPLICATION_SUBMISSION}-id-type`]: videogame.SubmissionDetails.ExpressService || 'No',
                [`${APPLICATION_SUBMISSION}-attachments`]: attachmentRetrieve(videogame.SubmissionDetails?.AttachmentList) || ''
            }
        };

        videoGamesDetails = {
            id: `videogames-details`,
            formID: 'videogamesDetails',
            title: 'Video Games Details',
            hasError: true,
            values: {
                [`${TITLE_DETAILS}-case-id`]: _content?.caseid || '',
                [`${TITLE_DETAILS}-_title`]: videogame.Title || '',
                [`${TITLE_DETAILS}-romanized-title`]: videogame.RomanizedTitle || '',
                [`${TITLE_DETAILS}-publisher`]: videogame.Publisher || '',
                [`${TITLE_DETAILS}-year-production`]: videogame.ReleaseYear || '',
                [`${TITLE_DETAILS}-region`]: regionArr?.split(',') || [],
                [`${TITLE_DETAILS}-platform`]: platformArr?.split(',') || '',
                [`${TITLE_DETAILS}-others`]: videogame.OtherPlatform || '',

                [`${GENRE_DETAILS}-action`]: genre1 === 'Action' || genre2 === 'Action' ? 'Yes' : '',
                [`${GENRE_DETAILS}-action-sub-genre`]:
                    dropdownOpts?.Action.find((i: any) => i.optID === subGenre1 || i.optID === subGenre2)?.optID || '',
                [`${GENRE_DETAILS}-adventure`]: genre1 === 'Adventure' || genre2 === 'Adventure' ? 'Yes' : '',
                [`${GENRE_DETAILS}-adventure-sub-genre`]:
                    dropdownOpts?.Adventure.find((i: any) => i.optID === subGenre1 || i.optID === subGenre2)?.optID || '',
                [`${GENRE_DETAILS}-fighting`]: genre1 === 'Fighting' || genre2 === 'Fighting' ? 'Yes' : '',
                [`${GENRE_DETAILS}-fighting-sub-genre`]:
                    dropdownOpts?.Fighting.find((i: any) => i.optID === subGenre1 || i.optID === subGenre2)?.optID || '',
                [`${GENRE_DETAILS}-puzzle`]: genre1 === 'Puzzle' || genre2 === 'Puzzle' ? 'Yes' : '',
                [`${GENRE_DETAILS}-racing`]: genre1 === 'Racing' || genre2 === 'Racing' ? 'Yes' : '',
                [`${GENRE_DETAILS}-racing-sub-genre`]:
                    dropdownOpts?.Racing.find((i: any) => i.optID === subGenre1 || i.optID === subGenre2)?.optID || '',
                [`${GENRE_DETAILS}-rpg`]: genre1 === 'Role Playing Games(RPG)' || genre2 === 'Role Playing Games(RPG)' ? 'Yes' : '',
                [`${GENRE_DETAILS}-rpg-sub-genre`]:
                    dropdownOpts?.['Role Playing Games(RPG)'].find((i: any) => i.optID === subGenre1 || i.optID === subGenre2)?.optID || '',
                [`${GENRE_DETAILS}-simulation`]: genre1 === 'Simulation' || genre2 === 'Simulation' ? 'Yes' : '',
                [`${GENRE_DETAILS}-simulation-sub-genre`]:
                    dropdownOpts?.Simulation.find((i: any) => i.optID === subGenre1 || i.optID === subGenre2)?.optID || '',
                [`${GENRE_DETAILS}-sports`]: genre1 === 'Sports' || genre2 === 'Sports' ? 'Yes' : '',
                [`${GENRE_DETAILS}-other`]: genre1 === 'Other' || genre2 === 'Other' ? 'Yes' : '',
                [`${GENRE_DETAILS}-other-sub-genre`]:
                    dropdownOpts?.Other.find((i: any) => i.optID === subGenre1 || i.optID === subGenre2)?.optID || '',
                [`${GENRE_DETAILS}-strategy`]: genre1 === 'Strategy' || genre2 === 'Strategy' ? 'Yes' : '',
                [`${GENRE_DETAILS}-strategy-sub-genre`]:
                    dropdownOpts?.Strategy.find((i: any) => i.optID === subGenre1 || i.optID === subGenre2)?.optID || '',

                [`${OTHER_DETAILS}-ratings`]: selectedRatings || '',
                [`${OTHER_DETAILS}-esrb-rating`]: videogame.Ratings?.[1].AgenciesInputRemarks || '',
                [`${OTHER_DETAILS}-esrb-consumer-advice`]: videogame.Ratings?.[1].ConsumerAdvice || '',
                [`${OTHER_DETAILS}-pegi-rating`]: videogame.Ratings?.[2].AgenciesInputRemarks || '',
                [`${OTHER_DETAILS}-pegi-consumer-advice`]: videogame.Ratings?.[2].ConsumerAdvice || '',
                [`${OTHER_DETAILS}-acb-rating`]: videogame.Ratings?.[3].AgenciesInputRemarks || '',
                [`${OTHER_DETAILS}-acb-consumer-advice`]: videogame.Ratings?.[3].ConsumerAdvice || '',
                [`${OTHER_DETAILS}-cero-rating`]: videogame.Ratings?.[4].AgenciesInputRemarks || '',
                [`${OTHER_DETAILS}-cero-consumer-advice`]: videogame.Ratings?.[4].ConsumerAdvice || '',
                [`${OTHER_DETAILS}-others`]: videogame.Ratings?.[5].ConsumerAdvice || '',

                [`${CONTENT_QUESTIONS_I}-question`]: videogame.Question1Answer || '',
                [`${CONTENT_QUESTIONS_II}-question`]: videogame.Question2Answer || '',
                [`${CONTENT_QUESTIONS_III}-question`]: videogame.Question3Answer || '',
                [`${CONTENT_QUESTIONS_IV}-question`]: videogame.Question4Answer || '',

                [`${APPLICATION_SUBMISSION}-tentative-rating`]: videogame.TentativeRating || '',
                [`${APPLICATION_SUBMISSION}-format`]: videogame.SubmissionDetails.Format || '',
                [`${APPLICATION_SUBMISSION}-online-link`]: videogame.SubmissionDetails.OnlineLink || '',
                [`${APPLICATION_SUBMISSION}-id-username`]: videogame.SubmissionDetails.pyUserName || '',
                [`${APPLICATION_SUBMISSION}-password`]: videogame.SubmissionDetails.PasswordValue || '',
                [`${APPLICATION_SUBMISSION}-dateCombo-main`]: videogame.SubmissionDetails.AppointmentDate || '',
                [`${APPLICATION_SUBMISSION}-dateCombo-radio-day`]: videogame.SubmissionDetails.AppointmentTimeTo || '',
                [`${APPLICATION_SUBMISSION}-id-type`]: videogame.SubmissionDetails.ExpressService || 'No',
                [`${APPLICATION_SUBMISSION}-attachments`]:
                    attachmentRetrieve(videogame.SubmissionDetails?.AttachmentList) || attachmentRetrieve(attachmentsFromBEP) || ''
            }
        };
    }

    return newApplication
        ? [general, title, genre, others, question1, question2, question3, question4, appSubmission, videoGamesDetails]
        : [summary, general, title, genre, others, question1, question2, question3, question4, appSubmission, videoGamesDetails];
};

// eslint-disable-next-line complexity
export const formatSave = async (
    details: DetailsType,
    caseTypeID: string,
    pageInstructions: any[] = [],
    userRole?: string,
    action?: string,
    activeStep?: number,
    content?: any
) => {
    if (action === 'application-delete') return payloadFVGDeleteApplication;
    const general = details.forms.find((form: FormData) => form.id === 'generalApplicant' || form.id === 'generalCompany')?.values || {};
    let videogames = details.forms.find((form: FormData) => form.id === 'videogames-title')?.values || {};
    const videogamesGenre = details.forms.find((form: FormData) => form.id === 'videogames-genre')?.values || {};
    const videogamesOther = details.forms.find((form: FormData) => form.id === 'videogames-others')?.values || {};
    const videogamesQ1 = details.forms.find((form: FormData) => form.id === 'videogames-content-1')?.values || {};
    const videogamesQ2 = details.forms.find((form: FormData) => form.id === 'videogames-content-2')?.values || {};
    const videogamesQ3 = details.forms.find((form: FormData) => form.id === 'videogames-content-3')?.values || {};
    const videogamesQ4 = details.forms.find((form: FormData) => form.id === 'videogames-content-4')?.values || {};
    const appSubmission = details.forms.find((form: FormData) => form.id === 'videogames-submission')?.values || {};
    let additionalInformationContent =
        details.forms.find((form: FormData) => form.id === 'videogames-additional-information')?.values || {};
    const additionalInfo = content?.FVGApplication?.VideoGameDetails?.AdditionalInformation;
    const isAppend = Object.keys(additionalInfo?.[0] || {})?.length === 1;

    if (action === 'pendingaddinfo') {
        additionalInformationContent = {
            AdditionalInformation: [
                ...(!isAppend ? additionalInfo : []),
                {
                    Format: additionalInformationContent[`${ADDITIONAL_INFORMATION}-format`] || '',
                    pyUserName: additionalInformationContent[`${ADDITIONAL_INFORMATION}-id-username`] || '',
                    PasswordValue: additionalInformationContent[`${ADDITIONAL_INFORMATION}-password`] || '',
                    OnlineLink: additionalInformationContent[`${ADDITIONAL_INFORMATION}-online-link`] || '',
                    AppointmentDate: additionalInformationContent[`${ADDITIONAL_INFORMATION}-dateCombo-main`] || '',
                    AppointmentTimeTo: additionalInformationContent[`${ADDITIONAL_INFORMATION}-dateCombo-radio-day`] || '',
                    Remarks: additionalInformationContent[`${ADDITIONAL_INFORMATION}-remarks`] || ''
                }
            ]
        };

        return {
            content: {
                FVGApplication: {
                    VideoGameDetails: {
                        ...additionalInformationContent
                    }
                }
            }
        };
    }

    videogames = {
        ...videogames,
        ...videogamesGenre,
        ...videogamesOther,
        ...(activeStep === 3 && {
            ...videogamesQ1,
            ...videogamesQ2,
            ...videogamesQ3,
            ...videogamesQ4
        }),
        ...(activeStep === 4 && {
            ...appSubmission
        })
    };

    const genreMap: any = {
        action: 'Action',
        adventure: 'Adventure',
        fighting: 'Fighting',
        puzzle: 'Puzzle',
        racing: 'Racing',
        rpg: 'Role Playing Games(RPG)',
        simulation: 'Simulation',
        sports: 'Sports',
        other: 'Other',
        strategy: 'Strategy'
    };

    const subGenreMap: any = {
        action: 'Action',
        adventure: 'Adventure',
        fighting: 'Fighting',
        racing: 'Racing',
        rpg: 'Role Playing Games(RPG)',
        simulation: 'Simulation',
        other: 'Other',
        strategy: 'Strategy'
    };

    const selectedGenres = [];
    const selectedSubGenres = [];

    for (const key in genreMap) {
        if (videogames[`${GENRE_DETAILS}-${key}`] === 'Yes') {
            selectedGenres.push(genreMap[key]);
            if (selectedGenres.length === 2) break;
        }
    }

    for (const key in subGenreMap) {
        if (videogames[`${GENRE_DETAILS}-${key}-sub-genre`] !== '') {
            selectedSubGenres.push(videogames[`${GENRE_DETAILS}-${key}-sub-genre`]);
            if (selectedSubGenres.length === 2) break;
        }
    }

    const genre1 = [selectedGenres[0], selectedSubGenres[0]].filter(Boolean).join(selectedGenres[0] && selectedSubGenres[0] ? ', ' : '');
    const genre2 = [selectedGenres[1], selectedSubGenres[1]].filter(Boolean).join(selectedGenres[1] && selectedSubGenres[1] ? ', ' : '');

    const platform = videogames[`${TITLE_DETAILS}-platform`]?.toString();
    const sortPlatformOrder = platform?.includes('Others')
        ? platform
              .split(',')
              .map((s) => s.trim())
              .filter((i) => i !== 'Others')
              .concat('Others')
              .join(', ')
        : platform?.split(',').join(', ');
    const otherContactNumber = general[`${SECT_APPLICANT}-other-mobile-no-main`];

    return {
        caseTypeID,
        LoginType: userRole,
        content: {
            FEPActiveStep: activeStep,
            ...(activeStep === 4 && {
                FEPActiveStep: '5'
            }),
            ...(activeStep === 2 && {
                applicant: {
                    IDNo: general[`${SECT_APPLICANT}-idno`] || '',
                    IDType:
                        general[`${SECT_APPLICANT}-id-type`] === 'IDT'
                            ? 'NRIC'
                            : general[`${SECT_APPLICANT}-id-type`] === 'IDT2'
                              ? 'FIN'
                              : '',
                    pxObjClass: 'IMDA-Data-Applicant',
                    Salutation: general[`${SECT_APPLICANT}-salutaion`] || '',
                    Name: general[`${SECT_APPLICANT}-name`] || '',
                    // Nationality: general[`${SECT_APPLICANT}-nationality`] || '',
                    MailingAddress: {
                        BlockNumber: general[`${SECT_ADDRESS}-block-house`] || '',
                        BuildingName: general[`${SECT_ADDRESS}-building`] || '',
                        FloorNumber: general[`${SECT_ADDRESS}-floor`] || '',
                        UnitNumber: general[`${SECT_ADDRESS}-unit`] || '',
                        PostalCode: general[`${SECT_ADDRESS}-postal`] || '',
                        pxObjClass: 'IMDA-Data-Address',
                        StreetName: general[`${SECT_ADDRESS}-street`] || ''
                    },
                    ContactPage: {
                        EmailAddress: general[`${SECT_APPLICANT}-email`] || '',
                        OtherEmailAddress: general[`${SECT_APPLICANT}-other-email`] || '',
                        ContactNumber:
                            '+' +
                                general[`${SECT_APPLICANT}-mobile-no-country-code`] +
                                general[`${SECT_APPLICANT}-mobile-no-main`]?.toString() || '',
                        ...(otherContactNumber !== '' && {
                            OtherContactNumber:
                                '+' +
                                    general[`${SECT_APPLICANT}-other-mobile-no-country-code`] +
                                    general[`${SECT_APPLICANT}-other-mobile-no-main`]?.toString() || ''
                        }),
                        pxObjClass: 'IMDA-Data-ContactPage'
                    }
                }
            }),
            ...(activeStep === 2 &&
                userRole === 'corppass' && {
                    company: {
                        CompanyName: general[`${ORGANISATION_DETAILS}-organisation-name`] || '',
                        UEN: general[`${ORGANISATION_DETAILS}-organisation-uen-no`] || '',
                        // Address: [
                        //     {
                        //         pxObjClass: 'IMDA-Data-Address',
                        //         MailingAddress: {
                        //             BlockNumber: general[`${SECT_ADDRESS}-block-house`] || '',
                        //             BuildingName: general[`${SECT_ADDRESS}-building`] || '',
                        //             FloorNumber: general[`${SECT_ADDRESS}-floor`] || '',
                        //             UnitNumber: general[`${SECT_ADDRESS}-unit`] || '',
                        //             PostalCode: general[`${SECT_ADDRESS}-postal`] || '',
                        //             pxObjClass: 'IMDA-Data-Address',
                        //             StreetName: general[`${SECT_ADDRESS}-street`] || ''
                        //         }
                        //     }
                        // ],
                        MailingAddress: {
                            BlockNumber: general[`${SECT_ADDRESS}-block-house`] || '',
                            BuildingName: general[`${SECT_ADDRESS}-building`] || '',
                            FloorNumber: general[`${SECT_ADDRESS}-floor`] || '',
                            UnitNumber: general[`${SECT_ADDRESS}-unit`] || '',
                            PostalCode: general[`${SECT_ADDRESS}-postal`] || '',
                            pxObjClass: 'IMDA-Data-Address',
                            StreetName: general[`${SECT_ADDRESS}-street`] || ''
                        },
                        ContactPage: {
                            MobileNo: general[`${ORGANISATION_DETAILS}-organisation-mobile-no-main`] || '',
                            MobileNoCountryCode: general[`${ORGANISATION_DETAILS}-organisation-mobile-no-country-code`] || '',
                            EmailAddress: general[`${ORGANISATION_DETAILS}-organisation-email`] || '',
                            pxObjClass: 'IMDA-Data-ContactPage'
                        }
                    }
                }),
            ...(activeStep === 2 && {
                IDNo: general[`${SECT_APPLICANT}-idno`] || '',
                DraftTitle: videogames[`${TITLE_DETAILS}-title`] || ''
            }),
            FVGApplication: {
                VideoGameDetails: {
                    ...(activeStep === 2 && {
                        Title: videogames[`${TITLE_DETAILS}-_title`] || '',
                        RomanizedTitle: videogames[`${TITLE_DETAILS}-romanized-title`] || '',
                        Publisher: videogames[`${TITLE_DETAILS}-publisher`] || '',
                        ReleaseYear: videogames[`${TITLE_DETAILS}-year-production`] || '',
                        Region: videogames[`${TITLE_DETAILS}-region`].toString().split(',').join(', ') || '',
                        Platform: sortPlatformOrder || '',
                        OtherPlatform: videogames[`${TITLE_DETAILS}-others`] || '',
                        Genre1: genre1 || '',
                        Genre2: genre2 || '',
                        Ratings: [
                            {
                                pxObjClass: 'IMDA-FVGCS-Data-FVG-AgencyInput',
                                Agency: 'No Rating Available',
                                pySelected: videogames[`${OTHER_DETAILS}-ratings`]
                                    .toString()
                                    .split(',')
                                    .find((i) => i === 'No Rating Available')
                                    ? 'true'
                                    : 'false'
                            },
                            {
                                pxObjClass: 'IMDA-FVGCS-Data-FVG-AgencyInput',
                                Agency: 'ESRB Rating',
                                AgenciesInputRemarks: videogames[`${OTHER_DETAILS}-esrb-rating`],
                                pySelected: videogames[`${OTHER_DETAILS}-ratings`]
                                    .toString()
                                    .split(',')
                                    .find((i) => i === 'ESRB Rating')
                                    ? 'true'
                                    : 'false',
                                ConsumerAdvice: videogames[`${OTHER_DETAILS}-esrb-consumer-advice`]
                            },
                            {
                                pxObjClass: 'IMDA-FVGCS-Data-FVG-AgencyInput',
                                Agency: 'PEGI Rating',
                                AgenciesInputRemarks: videogames[`${OTHER_DETAILS}-pegi-rating`],
                                pySelected: videogames[`${OTHER_DETAILS}-ratings`]
                                    .toString()
                                    .split(',')
                                    .find((i) => i === 'PEGI Rating')
                                    ? 'true'
                                    : 'false',
                                ConsumerAdvice: videogames[`${OTHER_DETAILS}-pegi-consumer-advice`]
                            },
                            {
                                pxObjClass: 'IMDA-FVGCS-Data-FVG-AgencyInput',
                                Agency: 'ACB Rating',
                                AgenciesInputRemarks: videogames[`${OTHER_DETAILS}-acb-rating`],
                                pySelected: videogames[`${OTHER_DETAILS}-ratings`]
                                    .toString()
                                    .split(',')
                                    .find((i) => i === 'ACB Rating')
                                    ? 'true'
                                    : 'false',
                                ConsumerAdvice: videogames[`${OTHER_DETAILS}-acb-consumer-advice`]
                            },
                            {
                                pxObjClass: 'IMDA-FVGCS-Data-FVG-AgencyInput',
                                Agency: 'CERO Rating',
                                AgenciesInputRemarks: videogames[`${OTHER_DETAILS}-cero-rating`],
                                pySelected: videogames[`${OTHER_DETAILS}-ratings`]
                                    .toString()
                                    .split(',')
                                    .find((i) => i === 'CERO Rating')
                                    ? 'true'
                                    : 'false',
                                ConsumerAdvice: videogames[`${OTHER_DETAILS}-cero-consumer-advice`]
                            },
                            {
                                pxObjClass: 'IMDA-FVGCS-Data-FVG-AgencyInput',
                                Agency: 'Others',
                                pySelected: videogames[`${OTHER_DETAILS}-ratings`]
                                    .toString()
                                    .split(',')
                                    .find((i) => i === 'Others')
                                    ? 'true'
                                    : 'false',
                                ConsumerAdvice: videogames[`${OTHER_DETAILS}-others`]
                            }
                        ]
                    }),
                    ...(activeStep === 3 && {
                        Question1Answer: videogames[`${CONTENT_QUESTIONS_I}-question`] || '',
                        Question2Answer: videogames[`${CONTENT_QUESTIONS_II}-question`] || '',
                        Question3Answer:
                            videogames[`${CONTENT_QUESTIONS_II}-question`] === 'Yes'
                                ? ''
                                : videogames[`${CONTENT_QUESTIONS_III}-question`] || '',
                        Question4Answer:
                            videogames[`${CONTENT_QUESTIONS_II}-question`] === 'Yes' ||
                            videogames[`${CONTENT_QUESTIONS_III}-question`] === 'Yes'
                                ? ''
                                : videogames[`${CONTENT_QUESTIONS_IV}-question`] || ''
                    }),
                    ...(activeStep === 4 && {
                        SubmissionDetails: {
                            Format: videogames[`${APPLICATION_SUBMISSION}-format`] || '',
                            pyUserName: videogames[`${APPLICATION_SUBMISSION}-id-username`] || '',
                            PasswordValue: videogames[`${APPLICATION_SUBMISSION}-password`] || '',
                            OnlineLink: videogames[`${APPLICATION_SUBMISSION}-online-link`] || '',
                            AppointmentDate: videogames[`${APPLICATION_SUBMISSION}-dateCombo-main`] || '',
                            AttachmentList: attachmentPayloadSetting(
                                (videogames[`${APPLICATION_SUBMISSION}-attachments`] || []) as Attachment[]
                            ),
                            AppointmentTimeTo: videogames[`${APPLICATION_SUBMISSION}-dateCombo-radio-day`] || '',
                            ...((videogames[`${APPLICATION_SUBMISSION}-tentative-rating`] === 'Refused Classification' ||
                                videogames[`${APPLICATION_SUBMISSION}-tentative-rating`] === 'Mature 18') && {
                                ExpressService: videogames[`${APPLICATION_SUBMISSION}-id-type`] || ''
                            })
                        }
                    })
                }
            }
        },
        ...(pageInstructions?.length > 0 && { pageInstructions })
    };
};

const videogamesPayload = {
    formatRetrieve,
    autoFillData,
    formatSave
};

export default videogamesPayload;
